// src/pages/config.js
// Resolve the correct base URL for API calls based on the current hostname.
// Examples:
//   stasney.ogfieldticket.ogpumper.net → https://stasney.ogfieldticket.ogpumper.net
//   testtwo.ogfieldticket.ogpumper.net → https://testtwo.ogfieldticket.ogpumper.net
//   anything else → fallback to https://testtwo.ogfieldticket.ogpumper.net

const getBaseUrl = () => {
  const hostname = window.location.hostname || "";

  // Local dev (CRA dev server) → point at a known tenant for convenience.
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]"
  ) {
    return "https://testtwo.ogfieldticket.ogpumper.net";
  }

  // Production: the PHP API is ALWAYS same-origin with the app on every tenant
  // (<tenant>.ogfieldticket.ogpumper.net AND <tenant>.ogfieldticket.com). Using the
  // current origin keeps requests on the correct tenant DB and avoids CORS. The old
  // code reconstructed the host and silently fell back to the "testtwo" tenant for
  // any non-.ogpumper.net host (e.g. .com), so phones loaded from .com fetched the
  // WRONG tenant's data — the "no tickets on mobile" symptom.
  return window.location.origin;
};

export const baseUrl = getBaseUrl();

// API version tag (useful if you roll versioned endpoints later)
export const API_VERSION = "v1";
